import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["onClick"];
const _hoisted_2 = ["onClick"];
import { reactive, inject } from "vue";
import { getProjectfile, getTaskdata, copystr, downloadzl } from "../../utils/lc";
import { ElMessage } from 'element-plus';

/* 数据层 */

export default {
  __name: 'lcDailogzl',
  props: ['dialogVisible'],
  emits: ['update:dialogVisible'],
  setup(__props, {
    emit: __emit
  }) {
    const data = reactive({
      tablelist: [],
      taskList: [],
      // 任务列表
      title: '',
      // 项目名称
      task_id: '',
      // 任务名称id
      projectId: '',
      downloadclick: []
    });
    data.projectId = JSON.parse(JSON.stringify(inject('project_id')));
    const emits = __emit;
    /* 初始化 */
    //获取任务下拉数据
    getTaskdata().then(res => {
      data.taskList = [];
      data.taskList = res;
    });
    //获取项目资料列表
    getInfo();
    /* 方法层 */
    //复制
    function copyline(it) {
      copystr(it.title);
    }
    // 下载
    function downloadFile(item, index) {
      if (data.downloadclick[index]) {
        data.downloadclick[index] = false;
        if (item.url) {
          // download(item.url, item.title) // 这里改了downloadjs原生方法，本来是三个参数的，第一个参数不接受url所以改动了
          downloadzl(item.url, item.title);
        } else {
          ElMessage.error('没有要下载的内容');
          data.downloadclick[index] = true;
        }
        setTimeout(function () {
          data.downloadclick[index] = true;
        }, 30000); //秒内不能再次点击
      } else {
        ElMessage.error('重复点击，请稍后再试');
      }
    }

    // 获取资料下载表格信息
    function getInfo() {
      getProjectfile({
        project_id: data.projectId,
        title: data.title,
        task_id: data.task_id
      }).then(res => {
        data.tablelist = [];
        data.tablelist = res;
        data.downloadclick = [];
        data.tablelist.forEach(it => {
          data.downloadclick.push(true);
        });
      });
    }
    // 搜索
    function search() {
      getInfo();
    }
    // 重置
    function reset() {
      data.task_id = '';
      data.title = '';
      getInfo();
    }
    //关闭的点击事件
    function handleClose() {
      emits('update:dialogVisible', false);
    }
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        title: "项目输出资料表",
        "model-value": __props.dialogVisible,
        width: "650px",
        "before-close": handleClose,
        center: false,
        class: "lcxmzl"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          inline: true,
          model: data,
          class: "demo-form-inline"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "任务名称"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: data.task_id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.task_id = $event),
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.taskList, (it, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: it.name,
                  value: it.basetask_id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "文件名称"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.title,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => data.title = $event),
              placeholder: "请输入"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createElementVNode("div", {
            class: "d_bts"
          }, [_createElementVNode("div", {
            class: "l-button",
            onClick: search
          }, "搜索"), _createElementVNode("div", {
            class: "l-button",
            onClick: reset
          }, "重置")])]),
          _: 1
        }, 8, ["model"]), _createVNode(_component_el_table, {
          data: data.tablelist,
          stripe: "",
          style: {
            "width": "100%"
          },
          border: "",
          "max-height": "600"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "task_name",
            label: "任务名称"
          }), _createVNode(_component_el_table_column, {
            prop: "title",
            label: "文件名称"
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            width: "100",
            align: "center"
          }, {
            default: _withCtx(scope => [scope.row.url_type == 'file' ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              type: "text",
              size: "small",
              onClick: $event => downloadFile(scope.row, scope.$index),
              style: {
                "cursor": "pointer",
                "color": "#409EFF"
              }
            }, "下载", 8, _hoisted_1)) : _createCommentVNode("", true), scope.row.url_type == 'link' ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              type: "text",
              size: "small",
              onClick: $event => copyline(scope.row),
              style: {
                "cursor": "pointer",
                "color": "#409EFF"
              }
            }, "复制", 8, _hoisted_2)) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])]),
        _: 1
      }, 8, ["model-value"])]);
    };
  }
};